import React, { useCallback } from "react";
import PropTypes from "prop-types";
import "./Loader.scss";
import LoaderGif from "assets/icons/ava2.gif";
import PumaLoader from "assets/icons/PumaLoader.gif";
import LinearProgress from "@mui/material/LinearProgress";
import { getPaletteColor, isTouchFriendly } from "utils";
import { useParams, useLocation } from "react-router-dom";

const Loader = ({
  children,
  className,
  onClick,
  setRef,
  progress = "",
  brand = "",
}) => {
  const { primaryColor } = getPaletteColor();
  let { domain } = useParams();
  const location = useLocation();
  const urlBrand = new URLSearchParams(location.search).get("outerBrand") || "";
  const getLoader = useCallback(() => {
    const LoaderGifObj = {
      puma: (
        <div className="LoaderContainer">
          <img src={PumaLoader} alt="Loading" />
        </div>
      ),
      cava: (
        <div className="CavaLoader">
          <img
            src={"https://assets.dopplr.info/cava/cava.gif"}
            alt="Loading"
          />
        </div>
      ),
      beinghuman: (
        <div className="LoaderContainer">
          <img
            src={
              "https://assets.dopplr.info/beinghuman/plugindefaults/loader.gif"
            }
            alt="Loading"
          />
        </div>
      ),
      beinghumans: (
        <div className="LoaderContainer">
          <img
            src={
              "https://assets.dopplr.info/beinghuman/plugindefaults/loader.gif"
            }
            alt="Loading"
          />
        </div>
      ),
      superkicks: (
        <div className="SuperkicksLoaderContainer">
          <img
            src={
              "https://assets.dopplr.info/superkicks/superkicksLoader.gif"
            }
            alt="Loading"
          />
        </div>
      ),
      indianterrain: (
        <div className="SuperkicksLoaderContainer">
          <img
            src={
              "https://assets.dopplr.info/indianterrain/indianterrain.gif"
            }
            alt="Loading"
          />
        </div>
      ),
      "indianterrain-demo": (
        <div className="SuperkicksLoaderContainer">
          <img
            src={
              "https://assets.dopplr.info/indianterrain/indianterrain.gif"
            }
            alt="Loading"
          />
        </div>
      ),
      "indianterrain-live": (
        <div className="SuperkicksLoaderContainer">
          <img
            src={
              "https://assets.dopplr.info/indianterrain/indianterrain.gif"
            }
            alt="Loading"
          />
        </div>
      ),
      rarerabbit: (
        <div className="RareLoaderContainer">
          <img
            src={
              "https://assets.dopplr.info/rarerabbit/RareRabbitDark.gif"
            }
            alt="Loading"
          />
        </div>
      ),
      enamor: (
        <div className="SuperkicksLoaderContainer">
          <img
            src={
              "https://assets.dopplr.info/enamor/enamorLoader.png"
            }
            alt="Loading"
          />
        </div>
      ),
      fila: (
        <div className="SuperkicksLoaderContainer">
          <img
            src={
              "https://afiles.webengage.com/76ab948/8aa58910-b4ac-4c66-bad8-cf57cd79872c.png"
            }
            alt="Loading"
          />
        </div>
      ),
      stylox: (
        <div className="SuperkicksLoaderContainer">
          <img
            src={
              "https://assets.dopplr.info/stylox/styloxLoader.avif"
            }
            alt="Loading"
          />
        </div>
      ),
      barenecessities: (
        <div className="SuperkicksLoaderContainer">
          <div style={{
            fontFamily: "'Georgia', 'Times New Roman', serif",
            fontSize: "20px",
            fontWeight: 400,
            letterSpacing: "0.12em",
            color: "#1a1a1a",
            textAlign: "center",
            lineHeight: 1.3,
          }}>
            Bare<br />Necessities
          </div>
        </div>
      ),
      jockey: (
        <div className="SuperkicksLoaderContainer">
          <div style={{
            fontFamily: "'Arial', 'Helvetica Neue', sans-serif",
            fontSize: "28px",
            fontWeight: 900,
            letterSpacing: "0.18em",
            color: "#1a1a1a",
            textTransform: "uppercase",
            textAlign: "center",
          }}>
            JOCKEY
          </div>
        </div>
      ),
    };
    const lookupKey = urlBrand || domain;
    const key = Object.keys(LoaderGifObj).find((key) => {
      return lookupKey === key;
    });
    if (key && LoaderGifObj[key]) {
      return LoaderGifObj[key];
    }
    return (
      <div className="LoaderContainer">
        <img src={LoaderGif} alt="Loading" />
      </div>
    );
  }, [urlBrand, domain]);

  const progressText = progress
    ? Number(progress) < 99
      ? `Loading assets ${progress}%`
      : "Generating avatar..."
    : "Loading...";
  return (
    <div className={`AppLoader ${className}`}>
      {getLoader()}
      <div
        style={{
          height: "30px",
          width: "45%",
          textAlign: "center",
          color: primaryColor ? primaryColor : "#000",
        }}
      >
        <div className="AppLoader__Progress">{progressText}</div>
        {Number(progress) > 0 && (
          <LinearProgress
            color="inherit"
            sx={{
              width: "100%",
              zIndex: 1,
              position: "relative",
              marginTop: "0.5em",
            }}
            variant="determinate"
            value={Number(progress)}
          />
        )}
      </div>
    </div>
  );
};

Loader.propTypes = {
  children: PropTypes.node,
};

Loader.defaultProps = {
  children: null,
};

export default Loader;
